import 'vite/modulepreload-polyfill';
import { revive, islands } from '@/js/revive.js';
import { installHashFocus } from '@/js/hash-focus.js';

// Polyfill for Object.hasOwn (https://github.com/ungap/has-own)
'hasOwn' in Object || (Object.hasOwn = Object.call.bind(Object.hasOwnProperty));

revive(islands);
installHashFocus();
